import { createContext } from 'react';
import { LeaderboardConfig } from 'api';

export const UserLeaderboardsContext = createContext<LeaderboardConfig[]>([]);
export const UserLeaderboardsProvider = UserLeaderboardsContext.Provider;
